import { createContext, useCallback, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "it", setLang: () => {}, tr: (o) => o?.it });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("aeras_lang") || "it");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("aeras_lang", l);
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const tr = useCallback(
    (o) => (o && typeof o === "object" && !Array.isArray(o) ? o[lang] ?? o.it : o),
    [lang]
  );
  return <LangContext.Provider value={{ lang, setLang, tr }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
